import BodyContainer from "../components/BodyContainer";
import {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import MessageBox from "../components/MessageBar";
import {
    Button,
    Subtitle1, Table, TableBody, TableCell, TableHeader, TableHeaderCell, TableRow,
    Title1
} from "@fluentui/react-components";

import ProgressRing from "../components/ProgressRing";
import {
    deleteParticipantByIdFromDatabase,
    fetchClubIDFromDatabase,
    fetchParticipantsByClubIDFromDatabase, fetchWSVusageFromDatabase
} from "../handlers/databasehandler";
import ChangeParticipantDialog from "../components/ChangeParticipantDialog";
import {Add12Filled, Delete16Filled, Edit16Filled} from "@fluentui/react-icons";
import ConfirmDialog from "../components/ConfirmDialog";

const ParticipantsView = () => {
    const { id } = useParams();
    const [errorMsg, setErrorMsg] = useState(null);
    const [loading, setLoading] = useState(true);
    const [fetchedParticipants, setFetchedParticipants] = useState(null);
    const [clubId, setClubId] = useState(null);

    const ParticipantTableColumns = [
        { columnKey: "name", label: "Naam", span: 11 },
        { columnKey: "actions", label: "Acties", span: 1 },
    ]

    const getWidthForColumnForParticipant = (columnKey) => {
        const column = ParticipantTableColumns.find(col => col.columnKey === columnKey);

        switch (column?.columnKey) {
            case "name":
                return "calc(100% - 75px)";
            case "actions":
                return "75px";
            default:
                return 'auto';
        }
    };

    async function fetchParticipants() {
        try {
            const clubId = await fetchClubIDFromDatabase();
            setClubId(clubId.id);
            return await fetchParticipantsByClubIDFromDatabase(clubId.id);
        } catch (error) {
            console.error(error);
            return null;
        }
    }

    function loadParticipants() {
        fetchParticipants().then(data => {
            setLoading(false)
            if (!data && !(data instanceof Array)) {
                setErrorMsg("Fout bij ophalen gegevens");
            } else {
                setFetchedParticipants(data)
            }        });
    }

    async function deleteParticipant(participantId) {
        if (await deleteParticipantByIdFromDatabase(participantId)) {
            loadParticipants();
        }
    }

    useEffect(() => {
        loadParticipants();
    }, []);


    return (
        <BodyContainer showBackButton={true} content={
            <>
                {errorMsg != null ? <MessageBox intent={"error"} title={"Error loading participants"} message={errorMsg} closeButtonFunction={() => {setErrorMsg(null)}}/> : null}
                <div style={{ display: "flex", flexDirection: "column" }}>
                    <Title1>Deelnemers</Title1>
                    <Subtitle1>Voeg toe, wijzig of verwijder deelnemers van de vereniging</Subtitle1>
                </div>
                {loading ?
                    <ProgressRing/>
                    : null
                }
                {fetchedParticipants !== null &&
                    <>
                        <Table className={`table`}>
                            <TableHeader>
                                <TableRow>
                                    {
                                        ParticipantTableColumns.map(col => (
                                            <TableHeaderCell key={col.columnKey} className={`table-header`} style={{ width: getWidthForColumnForParticipant(col.columnKey) }}>
                                                <b>{col.label}</b>
                                            </TableHeaderCell>
                                        ))
                                    }
                                </TableRow>
                            </TableHeader>
                            <TableBody>
                                { fetchedParticipants.length === 0 && <TableRow><TableCell colSpan={3}>No registrations found</TableCell></TableRow> }
                                {
                                    fetchedParticipants.map((participant) => (
                                        <TableRow key={participant.id}>
                                            <TableCell>
                                                {`${participant.first_name} ${participant.last_name}`}
                                            </TableCell>
                                            <TableCell>
                                                <div className={`flex flex-gap-medium`}>
                                                    <ChangeParticipantDialog
                                                        fetchedParticipant={participant}
                                                        verifiedStatus={"VERIFIED"}
                                                        onAdded={loadParticipants}
                                                        appearance={`subtle`}
                                                        buttonSize={`small`}
                                                        altButton={
                                                            <Button as={`a`} className={`button`} appearance={`subtle`} size={`small`} icon={<Edit16Filled/>} />
                                                        }
                                                    />
                                                    <ConfirmDialog
                                                        title={"Deelnemer verwijderen?"}
                                                        description={"Weet u zeker dat deze deelnemer moet worden verwijderd? Deze actie kan niet ongedaan worden gemaakt"}
                                                        buttonText={"Verwijderen"}
                                                        onConfirm={() => deleteParticipant(participant.id)}
                                                        buttonColor={"red"}
                                                        appearance={`subtle`}
                                                        buttonSize={`small`}
                                                        altButton={
                                                            <Button as={`a`} className={`button`} appearance={`subtle`} size={`small`} icon={<Delete16Filled/>}/>
                                                        }
                                                    />
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    ))
                                }
                            </TableBody>
                        </Table>
                    </>
                }
                <div style={{ display: "flex" }}>
                    <ChangeParticipantDialog buttonText={<><Add12Filled/> Deelnemer Toevoegen</>} fetchedParticipant={null} onAdded={async () => {setFetchedParticipants(await fetchParticipants())}} clubId={clubId} />
                </div>
            </>
        }/>
    )
}

export default ParticipantsView;